import psHttp, { RequestChannel, psHttp$ } from '@patsnap/common-ps-http';
import { homeApiUrlPrefix } from '../../config/constants';
import dayjs from 'dayjs';

const fetchChannelA = new RequestChannel(psHttp$);

export const getInit = () => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/init`
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getBasic = () => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/basic`,
        cache: true
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getSearchHistory = () => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/search/history`,
        params: {
            tzOffset: dayjs().utcOffset()
        }
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getRecentWork = () => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/recent/work`
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getQuickTask = () => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/quick/task`
    }).then(({ data }) => {
        return data.data || [];
    });
};

export const getQuickTaskSetting = () => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/quick/task/setting`
    }).then(({ data }) => {
        return data.data || [];
    });
};

export const setQuickTask = (taskList) => {
    return psHttp({
        method: 'POST',
        url: `${homeApiUrlPrefix}/quick/task/setting`,
        data: taskList
    }).then(({ data }) => {
        return data.data || [];
    });
};

export const getFeedList = (page = 1, rows = 20) => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/feed/list`,
        params: {
            page,
            rows
        }
    }).then(({ data }) => {
        return data.data || [];
    });
};

export const getOnboardingInit = (params = {}) => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/on-boarding/init`,
        params
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getOnboardingTopicList = ({ organization_role, onboarding = true }) => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/on-boarding/topic`,
        params: {
            organization_role,
            onboarding
        }
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getAutoCompleteList = (type, prefix) => {
    return fetchChannelA.requestAsPromise({
        method: 'POST',
        url: `${homeApiUrlPrefix}/on-boarding/${type}/auto-complete`,
        data: {
            prefix
        }
    }).then(({ data }) => {
        return data || [];
    });
};

export const submitOnboardingData = (data, params = {}) => {
    return psHttp({
        method: 'POST',
        url: `${homeApiUrlPrefix}/on-boarding/submit`,
        data,
        params
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const searchAssignApi = (keyword) => {
    return psHttp({
        url: `${homeApiUrlPrefix}/on-boarding/assignee`,
        method: 'GET',
        params: {
            keyword
        }
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const saveTopicApi = (data) => {
    return psHttp({
        method: 'POST',
        url: `${homeApiUrlPrefix}/topic/save`,
        data
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getCandidateTopicList = (data) => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/topic/candidate/list`,
        data
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getDynamicContent = () => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/dynamic-content`,
        cache: true
    }).then(({ data }) => {
        return data.data || [];
    });
};

export const getPictureInvisible = () => {
    return psHttp({
        method: 'GET',
        url: `${homeApiUrlPrefix}/dynamic-picture/invisible`,
        cache: true
    }).then(({ data }) => {
        return data.data || [];
    });
};
